import React from 'react';
import { useQueryClient } from 'react-query';
import { withStyles } from "@material-ui/core/styles";
import { useAircraftBlendedRate } from "../../../services/aircraft";
import {MaskedNumber} from "../../../controls";

/* eslint-disable no-use-before-define */
const styles = (theme) => ({
  popper: {
    maxWidth: "fit-content"
  }
});

const AircraftBlendedRate = props => {
  const queryClient = useQueryClient();
  const extraKeys = [props.poolUuid, props.acmiRate, props.validFrom];
  const blendedRate = useAircraftBlendedRate({queryClient, extraKeys});

  if (blendedRate && blendedRate.data) {
    return <MaskedNumber
      displayType="text"
      value={blendedRate.data}
      decimalScale={2}
      fixedDecimalScale={true}
    />
  }
  return <></>
}

export default withStyles(styles) (AircraftBlendedRate);
